import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import theme from '@/theme';
import styled from '@emotion/styled';
import Linear from '../../../images/Linear.svg';

const Container = styled.div<{ hidden?: boolean }>`
    background: ${({ theme }) => theme.colors.black[100]};
    align-items: center;
    width: 100%;
    height: 50px;
    border-radius: 8px;
    font-size: 12px;
    display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
    margin-bottom: 14px;
`;

const Text = styled.div`
    color: ${theme.colors.black.main};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin: 0px 8px;
`;

const LearnMore = styled.span`
    color: ${({ theme }) => theme.colors.black.main};
    font-weight: 700;
    cursor: pointer;
`;

const Icon = styled(MaskedIcon)`
    width: 24;
    height: 24;
    margin-left: 5px;
`;

export default function KnowledgeMessage({
    children,
    hidden,
    onLearnMore,
}: {
    children: string;
    hidden?: boolean;
    onLearnMore?: () => void;
}) {
    return (
        <Container hidden={hidden}>
            <Icon src={Linear} size="24px" />
            <div>
                <Text>
                    {children} {onLearnMore && <LearnMore onClick={onLearnMore}>Learn more</LearnMore>}
                </Text>
            </div>
        </Container>
    );
}
